import { useEffect, useRef, useState } from 'react';
import { Map, NavigationControl, Marker } from 'maplibre-gl';

import './admin-map.styl';

const storyMarker = new Marker();

function AdminMap({ className, item }) {
  const [adminMap, setAdminMap] = useState();

  const mapRef = useRef();

  useEffect(() => {
    const map = new Map({
      container: mapRef.current,
      attributionControl: false,
      style: `https://api.maptiler.com/maps/0198cd0d-152c-7df0-b467-fc64803317b3/style.json?key=${import.meta.env.VITE_MAPTILER_TOKEN}`,
    }).addControl(new NavigationControl({ showCompass: false }), 'top-right');

    setAdminMap(map);

    return () => {
      map.remove();
    };
  }, []);

  useEffect(() => {
    if (item && adminMap) {
      const { lat, lng } = item;
      storyMarker.setLngLat([lng, lat]).addTo(adminMap);
      adminMap.setCenter([lng, lat]);
      adminMap.setZoom(12);
    }
  }, [item, adminMap]);

  return (
    <div className={`admin-map z-depth-1 ${className || ''}`} ref={mapRef} />
  );
}

export default AdminMap;